import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const ScoreCardListDIV = styled.div`
    width: 100%;
`;

export const ScoreCardListWrapper = styled.div`
    padding: ${getBaseTheme().spaces.inset.s};
`;
